/**
 * Finishing - Galleries
 *
 * JS pour la gestion des galeries d'images
 *
 * @since       20.10.2015
 * @version     1.0.0.0
 * @author      e-novinfo
 * @copyright   e-novinfo 2015
 */

/************************************/
/********** DOCUMENT READY **********/
/************************************/

jQuery(document).ready(function() {
    
    jQuery( '.image-gallery-wrapper' ).magnificPopup({
        delegate: 'a',
		type: 'image',
		closeOnContentClick: false,
		closeBtnInside: false,
		mainClass: 'mfp-with-zoom mfp-img-mobile',
		image: {
			verticalFit: true,
			titleSrc: ''
		},
		gallery: {
			enabled: true
		},
		zoom: {
			enabled: true,
			duration: 300,
			opener: function(element) {
				return element.find( 'img' );
			}
		}
    //END jQuery( '.image-gallery-wrapper' ).magnificPopup   
    });

//END jQuery(document).ready
});
